export default function(text, query) {
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  };

  let escaped = text.replace(/[&<>"']/g, m => map[m]);

  if (!query || !query.length) {
    return escaped;
  }
  try {
    const regexp = new RegExp(
      '(' +
        query
          .trim()
          .replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
          .split(' ')
          .join('|') +
        ')',
      'gi'
    );

    return escaped.replace(regexp, function(s) {
      return '<mark class="marked">' + s + '</mark>';
    });
  } catch (e) {
    return escaped;
  }
}
